import Vue from 'vue'
import Router from 'vue-router'
import home from '../view/Home/home.vue'
import login from '../view/Login/login.vue'
import index from '../view/Home/index/index.vue'
import group from '../view/Home/group/group.vue'
import company from '../view/Home/company/company.vue'
import department from '../view/Home/department/department.vue'
import user from '../view/Home/user/user.vue'
import service_center from '../view/ServiceCenter/index.vue'
import smart_electricity from '../view/ServiceCenter/SmartElectricity/index.vue'
import smart_fire from '../view/ServiceCenter/SmartFire/index.vue'
import smart_community from '../view/ServiceCenter/SmartCommunity/index.vue'
import smart_statistics from '../view/ServiceCenter/SmartStatistics/index.vue'
import smart_energy from '../view/ServiceCenter/SmartEnergy/index.vue'

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'home',
		component: home,
		children: [{
			path: '/index',
			name: 'index',
			component: index,
		},{
			path: '/group',
			name: 'group',
			component: group,
		},{
			path: '/company',
			name: 'company',
			component: company,
		},{
			path: '/department',
			name: 'department',
			component: department,
		},{
			path: '/user',
			name: 'user',
			component: user,
		}], redirect:'/index'
	}, {
		path: '/service_center',
		name: 'service_center',
		component: service_center,
		children: [{
			path: '/smart_electricity',
			name: 'smart_electricity',
			component: smart_electricity,
		},{
			path: '/smart_fire',
			name: 'smart_fire',
			component: smart_fire,
		},{
			path: '/smart_community',
			name: 'smart_community',
			component: smart_community,
		},{
			path: '/smart_statistics',
			name: 'smart_statistics',
			component: smart_statistics,
		},{
			path: '/smart_energy',
			name: 'smart_energy',
			component: smart_energy,
		}], redirect:'/smart_electricity'
	}, {
		path: '/login',
		name: 'login',
		component: login
	}]
})
